import { useContext } from 'react';
import { PortalAccentContext, type PortalAccent } from '../context/portal-accent.context';

/**
 * Returns the surrounding portal's accent hue ('sky' in the user app, 'amber'
 * in the admin portal). Safe to call anywhere — defaults to 'sky' when no
 * provider is present.
 */
export function usePortalAccent(): PortalAccent {
  return useContext(PortalAccentContext);
}
